import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpRequestService } from "../shared/HttpRequestServices/HttpRequestService.service";

/** Client for weather data proxied through the backend. */
@Injectable({
  providedIn: "root",
})
export class WeatherApiControllerService {
  constructor(private readonly HttpRequestService: HttpRequestService) {}

  // Weather via backend (OpenWeatherMap proxy): https://openweathermap.org/weather-conditions
  // Response: { code, message, body }, with the OpenWeatherMap JSON in body.
  getWeatherData(
    latitude: number,
    longitude: number,
    lang: string,
  ): Observable<object> {
    // Note: payload key is 'Lang' (capitalized).
    return this.HttpRequestService.post("/weather/get", {
      latitude,
      longitude,
      lang: lang,
    });
  }
}
